import React from 'react';
import { Card } from '../types';

import p5Types from 'p5';

// @ts-ignore
function importAll(r: any) {
  const images: Record<string, any> = {};
  // @ts-ignore
  r.keys().forEach((item) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}

export const imageMap: Record<string, any> = importAll(
  // @ts-ignore
  require.context('../../asset/img/card', false, /\.(png|jpe?g|svg)$/),
);

export const getCardImageString = (card: Card) => {
  const imageString = `${card.value}_${card.color.toLowerCase()}.jpg`;
  return imageString;
};

export const getCardImage = (card: Card) => {
  const imageString = getCardImageString(card);
  const cardImage = imageMap[imageString as keyof typeof imageMap];
  return cardImage;
};

export const p5PreloadCardImages = (p5: p5Types): Record<string, any> => {
  const images: Record<string, any> = {};

  Object.keys(imageMap).forEach((key) => {
    images[key] = p5.loadImage(imageMap[key]);
  });

  return images;
};

export const p5GetCardImageSize = (multiplier = 1.0) => {
  return [331 * multiplier, 512 * multiplier];
};
